import fetch from "isomorphic-fetch";
import React from "react";
import { message, setIsFetching, setRoute, setTitleAndScrollToTop, setUserGuest } from "../../../actions";
import Configuration from "../../../config.js";
import ReactGA from "react-ga";
import { translations } from "../../../config";
import { setBasicCharge, setOrganizationLimit, setSurveyCosts } from "../../../actions/Users";

/**
 * Konstanten
 */
export const SET_QUESTIONNAIRES = "SET_QUESTIONNAIRES";
export const SET_QUESTIONNAIRE_ID = "SET_QUESTIONNAIRE_ID";
export const SET_INITIAL_QUESTIONNAIRES = "SET_INITIAL_QUESTIONNAIRES";
export const SET_QUESTIONNAIRES_OVERVIEW = "SET_QUESTIONNAIRES_OVERVIEW";
export const SET_ORDERABLE_QUESTIONNAIRES = "SET_ORDERABLE_QUESTIONNAIRES";

/**
 * Setter
 */
export function setQuestionnaires( json )
{
	return {
		type: SET_QUESTIONNAIRES,
		json
	};
}

export function setInitialQuestionnaires( json )
{
	return {
		type: SET_INITIAL_QUESTIONNAIRES,
		json
	};
}

export function setQuestionnairesOverview( json )
{
	return {
		type: SET_QUESTIONNAIRES_OVERVIEW,
		json
	};
}

export function setOrderableQuestionnaires( json )
{
	return {
		type: SET_ORDERABLE_QUESTIONNAIRES,
		json
	};
}

/**
 * Zeigt den gewählten Fragebogen
 *
 * @param id {number}
 */
export function getQuestionnaires( id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Questionnaire",
				action: `${translations.de_DE.words.questionnaire} laden`
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${id}?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									dispatch( setTitleAndScrollToTop( <h1 className={"col s12 m9 l11 white-text"}>{translations.de_DE.words.questionnaire}: {json.description}</h1> ) );
									dispatch( setQuestionnaires( json ) );
									
									// Overview aktualisieren
									const questionnaires = Object.assign(
										{},
										getState().questionnairesOverview,
										{ [id]: json }
									);
									dispatch( setQuestionnairesOverview( questionnaires ) );
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function getQuestionnaires(...)

/**
 * Überprüft den gewählten Fragebogen
 *
 * @param a_questionnaire {object}
 */
export function activateQuestionnaires( a_questionnaire )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Block",
				action: "Blöcke mit Fragen laden"
			} );
		}
		
		if ( a_questionnaire.active === "1" )
		{
			dispatch( setIsFetching( false ) );
			
			// Fragebogen deaktivieren
			return dispatch( patchQuestionnaires( { ...a_questionnaire, active: "0" } ) );
		}
		
		// Überprüft ob ein Preis eingetragen ist
		if ( typeof a_questionnaire.price === "undefined" )
		{
			dispatch( setIsFetching( false ) );
			
			return dispatch( message( "Die Aktivierung ist nicht möglich, da kein Preis definiert wurden.", "error" ) );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${a_questionnaire.id}/blocks?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									// Fragenliste erzeugen und im State ablegen
									let questions = {};
									
									Object.keys( json ).forEach(
										( a_block_key ) =>
										{
											Object.keys( json[a_block_key].questions ).forEach(
												( a_key ) =>
												{
													questions[a_key] = json[a_block_key].questions[a_key];
												}
											);
										}
									);
									
									// Wenn keine Fragen vorliegen
									if ( typeof questions === "undefined" || Object.keys( questions ).length === 0 )
									{
										return dispatch( message( "Die Aktivierung ist nicht möglich, da keine Fragen definiert wurden.", "error" ) );
									}
									
									// Überprüfe alle Fragen auf Vollständigkeit
									const valid = !Object.keys( questions ).filter(
										( a_key ) =>
										{
											// Wenn eine Frage unvollständige Antworten beinhaltet
											const incompleteAnswers = Object.keys( questions[a_key]["answers"] ).filter(
												( key ) =>
													( questions[a_key]["answers"][key].next_question_id !== null && questions[a_key]["answers"][key].result_text !== null )
											);
											
											// Wenn eine Frage keine Antworten beinhaltet
											return Object.keys( questions[a_key]["answers"] ).length === 0 || incompleteAnswers.length > 0;
										}
									).length;
									
									if ( !valid )
									{
										return dispatch( message( "Die Aktivierung ist nicht möglich, da nicht alle Folgeaktionen definiert wurden.", "error" ) );
									}
									
									// Fragebogen aktivieren
									dispatch( patchQuestionnaires( { ...a_questionnaire, active: "1" } ) );
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
	
} // function activateQuestionnaires(...)

/**
 * Lädt die gewählte Umfrage im gewählten Format herunter
 *
 * @param a_id {number}
 * @param a_format {string}
 */
export function downloadQuestionnaire( a_id, a_format = "pdf" )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Questionnaire",
				action: `${translations.de_DE.words.questionnaire} exportieren`
			} );
		}
		
		const { jwt, questionnairesOverview } = { ...getState() };
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${a_id}?format=${a_format}&${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						switch ( a_format )
						{
							case "pdf":
								response.blob().then( blob =>
									{
										let newBlob = new Blob( [ blob ], { type: "application/pdf" } );
										const fileName = `${translations.de_DE.words.questionnaire} ${questionnairesOverview[a_id].law} ${questionnairesOverview[a_id].title}.pdf`;
										
										if ( window.navigator.msSaveOrOpenBlob )
										{
											window.navigator.msSaveOrOpenBlob( newBlob, fileName );
										}
										else
										{
											let url = URL.createObjectURL( newBlob );
											let a = document.createElement( "a" );
											document.body.appendChild( a );
											a.style = "display: none";
											a.href = url;
											a.download = fileName;
											a.click();
											
											URL.revokeObjectURL( url );
										}
										dispatch( setIsFetching( false ) );
									}
								);
								break;
							default:
								break;
						}
						
					}
					else
					{
						response.json()
							.then( json =>
								{
									dispatch( message( json.error, "error" ) );
									dispatch( setIsFetching( false ) );
								}
							);
					}
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function downloadQuestionnaire(...)

/**
 * Zeigt alle Fragebögen in der Übersicht an
 */
export function getQuestionnairesOverview()
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Questionnaire",
				action: `${translations.de_DE.words.questionnairesOverview} laden`
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									// Das Kostenlimit und die Gesamtkosten werden aktualisert.
									dispatch( setOrganizationLimit( json.payment.monthly_limit ) );
									dispatch( setSurveyCosts( json.payment.survey_costs ) );
									dispatch( setBasicCharge( json.payment.basic_charge ) );
									dispatch( setQuestionnairesOverview( json.questionnaires ) );
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
					
					// setze Gastnutzer Erkennung
					dispatch( setUserGuest() );
				}
			);
	};
	
} // function getQuestionnairesOverview(...)

/**
 * Zeigt alle Fragebögen in der Übersicht an
 */
export function getOrderableQuestionnaires()
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Questionnaire",
				action: `Aktive ${translations.de_DE.words.questionnairesOverview} laden`
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/orders/questionnaires?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									dispatch( setOrderableQuestionnaires( json ) );
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function getOrderableQuestionnaires(...)

/**
 * Api-Anfrage: Neuen Fragebogen erstellen
 *
 * @param formDataObject {Object}
 */
export function createQuestionnaires( formDataObject )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Questionnaire",
				action: `${translations.de_DE.words.questionnaire} anlegen`
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		let formData = new FormData();
		formData.append( "title", formDataObject.title );
		formData.append( "description", formDataObject.description );
		formData.append( "long_description", formDataObject.long_description );
		formData.append( "law", formDataObject.law );
		formData.append( "sort_id", formDataObject.sort_id );
		formData.append( "price", formDataObject.price );
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires`,
			{
				credentials: "include",
				method: "POST",
				body: formData,
				headers
			}
		)
			.then(
				response =>
				{
					// Fragebogen angelegt
					if ( response.ok )
					{
						response.json()
							.then( id =>
								{
									// Da es nach erfolgreicher Erstellung einen neuen Fragebögen gibt, laden wir diesen erneut in den Store.
									dispatch( getQuestionnaires( id ) );
									
									// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
									dispatch( message( `${translations.de_DE.words.questionnaire} erfolgreich angelegt.`, "info", 5000 ) );
									
									// Zum Fragebogen-Bearbeiten umleiten
									dispatch( setRoute( `${translations.de_DE.routes.questionnaire}/${id}` ) );
								}
							);
					}
					// Eingabefehler oder Serverfehler
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function createQuestionnaires(...)

/**
 * Api-Anfrage: Fragebogen bearbeiten
 *
 * @param formDataObject {Object}
 */
export function patchQuestionnaires( formDataObject )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Questionnaire",
				action: `${translations.de_DE.words.questionnaire} ändern`
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		headers["content-type"] = "application/json";
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${formDataObject.id}`,
			{
				credentials: "include",
				method: "PATCH",
				headers,
				body: JSON.stringify(
					{
						title: formDataObject.title,
						description: formDataObject.description,
						long_description: formDataObject.long_description,
						law: formDataObject.law,
						sort_id: formDataObject.sort_id,
						active: formDataObject.active,
						price: formDataObject.price
					}
				)
			}
		)
			.then(
				response =>
				{
					// Fragebogen aktualisiert
					if ( response.ok )
					{
						// Fragebogentitel aktualisieren
						dispatch( setTitleAndScrollToTop( `${translations.de_DE.words.questionnaire}: ${formDataObject.description}` ) );
						
						// State aktualisieren
						dispatch( setQuestionnaires( formDataObject ) );
						
						// Overview aktualisieren
						const questionnaires = Object.assign(
							{},
							getState().questionnairesOverview,
							{ [formDataObject.id]: formDataObject }
						);
						dispatch( setQuestionnairesOverview( questionnaires ) );
						
						// Der Nutzer soll eine Notification erhalten, dass die Anfrage erfolgreich war.
						dispatch( message( `${translations.de_DE.words.questionnaire} erfolgreich geändert.`, "info", 5000 ) );
					}
					// Eingabefehler oder Serverfehler
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function patchQuestionnaires(...)

/**
 * Api-Anfrage: Fragebogen löschen
 *
 * @param id {number}
 */
export function deleteQuestionnaires( id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Questionnaire",
				action: `${translations.de_DE.words.questionnaire} löschen`
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${id}`,
			{
				credentials: "include",
				method: "DELETE",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						// Overview aktualisieren
						Object.keys( getState().questionnairesOverview ).forEach(
							( a_id ) =>
							{
								if ( a_id.toString() === id.toString() )
								{
									delete getState().questionnairesOverview[id];
								}
							}
						);
						
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						dispatch( message( `${translations.de_DE.words.questionnaire} erfolgreich gelöscht.`, "info", 5000 ) );
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function deleteQuestionnaires(...)